import React from "react";
import styles from "./popup.module.css";
import { X_Icon } from "../icons/icons.tsx";

type PopUpProps = {
  content: React.ReactElement;
  isCloseButton?: boolean;
  onClick: () => void;
};

export const PopUp = ({
  content,
  isCloseButton = false,
  onClick = () => {},
}: PopUpProps) => {
  return (
    <div className={styles.overlay} onClick={onClick}>
      <div
        className={styles.popup_container}
        onClick={(e) => e.stopPropagation()}
      >
        {isCloseButton && (
          <div onClick={onClick}>
            <X_Icon className={styles.popup_X_Icon} />
          </div>
        )}
        {content}
      </div>
    </div>
  );
};
